import React, { useMemo } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useLabels } from '../../hooks/useLabels';
import { usePermissions } from '../../hooks/usePermissions';
import { getVisibleSections } from './settingsNav';

/**
 * Settings landing: one card per group with links to its pages.
 */
export default function SettingsHome() {
	const { t } = useLabels();
	const { role } = usePermissions();
	const { search } = useLocation();
	const sections = useMemo(() => getVisibleSections(role), [role]);

	// Backwards compatibility: an already-deployed backend may still redirect
	// the Google OAuth callback to /AdminScreen/Config?googleConnected=1 —
	// forward those params to the calendar page that consumes them.
	const params = new URLSearchParams(search);
	if (params.has('googleConnected') || params.has('googleError')) {
		return <Navigate to={{ pathname: 'integraciones/calendar', search }} replace />;
	}

	return (
		<div className='settings-home'>
			<div className='settings-home-header'>
				<h1 className='settings-section-title'>{t('settings.title')}</h1>
				<p className='settings-section-description'>{t('settings.homeDescription')}</p>
			</div>
			<div className='settings-home-grid'>
				{sections.map((section) => {
					const GroupIcon = section.icon;
					return (
						<section key={section.key} className='settings-home-card'>
							<div className='settings-home-card-hd'>
								<GroupIcon className='settings-nav-icon' />
								<h3 className='settings-home-card-title'>{t(section.labelKey)}</h3>
							</div>
							{section.descriptionKey && (
								<p className='settings-home-card-description'>{t(section.descriptionKey)}</p>
							)}
							<div className='settings-home-card-links'>
								{section.items.map((item) => {
									const ItemIcon = item.icon;
									return (
										<Link
											key={item.path}
											to={item.path}
											className={`settings-home-card-link ${item.danger ? 'danger' : ''}`}
										>
											<ItemIcon className='settings-nav-icon' />
											{t(item.labelKey)}
										</Link>
									);
								})}
							</div>
						</section>
					);
				})}
			</div>
		</div>
	);
}
